// extracted by mini-css-extract-plugin
export default {"icon":"emoji_icon__rsMc8","tooltip":"emoji_tooltip__FlaPp","emoji":"emoji_emoji__SCyXe","wrapper":"emoji_wrapper__F-1t2"};